import ActivationCode from './ActivationCode';

export default ActivationCode;
